import { useId } from "react";

import { cn } from "@/common/utils";
import {
  CAT_CELLS,
  CAT_MARK_PATHS,
  CAT_VIEWBOX,
  catMarkTransform,
} from "@/landing/lib/pixel-cat";

/**
 * Wonda's pixel cat drawn in tiny LinkedIn, Sales Navigator, X and Reddit marks
 * with the accent in its eyes: the homepage hero's cat, still.
 */
export function PixelCat({
  className,
  title,
}: {
  className?: string;
  title?: string;
}) {
  const id = useId();
  return (
    <svg
      viewBox={CAT_VIEWBOX}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      className={cn("h-auto w-full", className)}
    >
      <defs>
        {CAT_MARK_PATHS.map((path, index) => (
          <path key={index} id={`${id}m${index}`} d={path} fillRule="evenodd" />
        ))}
      </defs>
      <g fill="rgb(22 25 28 / 90%)">
        {CAT_CELLS.filter((cell) => !cell.hot).map((cell) => (
          <use
            key={`${cell.x}.${cell.y}`}
            href={`#${id}m${cell.mark}`}
            transform={catMarkTransform(cell)}
          />
        ))}
      </g>
      <g fill="var(--g-accent, #b308a7)">
        {CAT_CELLS.filter((cell) => cell.hot).map((cell) => (
          <use
            key={`${cell.x}.${cell.y}`}
            href={`#${id}m${cell.mark}`}
            transform={catMarkTransform(cell)}
          />
        ))}
      </g>
    </svg>
  );
}

/** The interior hero's visual: the still cat at the size the homepage shows it. */
export function HeroCat({ className }: { className?: string }) {
  return (
    <PixelCat
      className={cn("mx-auto max-w-[min(440px,80vw)] lg:mr-0", className)}
    />
  );
}
